import Api  from './Api'
import axios from 'axios'

class EnrollmentDocumentsApi extends Api {
    async list(controlNumber){
        const request = async () => await axios.get(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos`));
            
        const { data } = await this.perform(request);

        return data;
    }

    async get(controlNumber, documentSlug){
        const request = async () => await axios.get(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos/${documentSlug}`));

        const { data } = await this.perform(request);

        return data;
    }

    async accept(controlNumber, documentSlug){
        const request = async () => await axios.put(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos/${documentSlug}/aceptar`));

        await this.perform(request);
    }

    async reject(controlNumber, documentSlug, reason){
        const request = async () => await axios.put(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos/${documentSlug}/rechazar`), { observaciones: reason });

        await this.perform(request);
    }

    async markAsPending(controlNumber, documentSlug, reason){
        const request = async () => await axios.put(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos/${documentSlug}/marcar-como-pendiente`), { razon: reason });

        await this.perform(request);
    }

    async unmarkAsPending(controlNumber, documentSlug){
        const request = async () => await axios.put(this.generateAbsolutePath(`inscripcion/${controlNumber}/documentos/${documentSlug}/desmarcar-como-pendiente`));

        await this.perform(request);
    }
}

export default EnrollmentDocumentsApi;